import { render, staticRenderFns } from "./PriTama05.vue?vue&type=template&id=6a53bb76&scoped=true&"
import script from "./PriTama05.vue?vue&type=script&lang=js&"
export * from "./PriTama05.vue?vue&type=script&lang=js&"
import style0 from "./PriTama05.vue?vue&type=style&index=0&id=6a53bb76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a53bb76",
  null
  
)

export default component.exports